/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PhoneTypeToggle/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PhoneTypeToggle({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/PhoneTypeToggle",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let contactDetailsPhonedetailsPhonetypeValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneType',
})
let constantData = 'CELL'
let aggregateData = fromAggregate.equals(contactDetailsPhonedetailsPhonetypeValueData, constantData)
let contactDetailsPhonedetailsPhonetypeChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneType',
})
let dtChoiceradialStrokeBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.stroke.brand.base'
        })
let dtChoiceradialBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.borderColor.brand.base'
        })
let dtChoiceradialBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.backgroundColor.brand.selected'
        })
let dtChoiceradialBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.borderColor.brand.hovered'
        })
let dtChoiceradialColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.color.brand.hovered'
        })
let dtChoiceradialColorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.color.brand.selected'
        })
let dtChoiceradialBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.backgroundColor.brand.base'
        })
let contactDetailsPhonedetailsPhonetypeValueData1 = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneType',
})
let constantData1 = 'LANDLINE'
let aggregateData1 = fromAggregate.equals(contactDetailsPhonedetailsPhonetypeValueData1, constantData1)
let contactDetailsPhonedetailsPhonetypeChangeData1 = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'phoneDetails.phoneType',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="PhoneTypeToggle.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2fudr9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-2fudr9': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="CELL"
 width={110}
 data="contactDetails.phoneDetails.phoneType"
 data="'CELL'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 data="contactDetails.phoneDetails.phoneType"
 onClick={contactDetailsPhonedetailsPhonetypeChangeData}
 stroke={dtChoiceradialStrokeBrandBase}
 borderColor={dtChoiceradialBordercolorBrandBase}
 backgroundColorSelected={dtChoiceradialBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceradialBordercolorBrandHovered}
 colorHovered={dtChoiceradialColorBrandHovered}
 colorSelected={dtChoiceradialColorBrandSelected}
 backgroundColor={dtChoiceradialBackgroundcolorBrandBase}
 text="Cell"
/>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="LANDLINE"
 width={110}
 marginLeft={dtSpaceXs}
 data="contactDetails.phoneDetails.phoneType"
 data="'LANDLINE'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 data="contactDetails.phoneDetails.phoneType"
 onClick={contactDetailsPhonedetailsPhonetypeChangeData1}
 stroke={dtChoiceradialStrokeBrandBase}
 backgroundColorSelected={dtChoiceradialBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceradialBordercolorBrandHovered}
 colorHovered={dtChoiceradialColorBrandHovered}
 colorSelected={dtChoiceradialColorBrandSelected}
 text="Landline"
/>
</div>
{children}
</React.Fragment>)
}